import React from 'react';
import { useSearchParams } from 'react-router-dom';
import TopBar from '@/components/layout/TopBar';
import SiteHeader from '@/components/layout/SiteHeader';
import BrandDivider from '@/components/brand/BrandDivider';
import CabBookingForm from '@/components/booking/CabBookingForm';

const VALID_TRIPS = ['one_way', 'round_trip', 'local_rental', 'airport_transfer'];

const VehicleBookingPage = () => {
  const [searchParams] = useSearchParams();
  const tripParam = searchParams.get('trip');
  const initialTripType = VALID_TRIPS.includes(tripParam) ? tripParam : 'one_way';

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-body">
      <TopBar />
      <SiteHeader showNav={false} showAdmin={false} backTo="/" backLabel="Back to Home" />

      <div
        className="bg-atithi-navy py-14 px-6 text-center text-white relative overflow-hidden"
        style={{
          backgroundImage:
            'linear-gradient(135deg, rgba(27,45,94,0.95) 0%, rgba(27,45,94,0.85) 100%)',
        }}
      >
        <BrandDivider className="mb-6" />
        <h1 className="text-3xl sm:text-4xl font-bold font-display mb-2" data-testid="booking-heading">
          Book Your Cab
        </h1>
        <p className="text-white/90 max-w-xl mx-auto text-sm sm:text-base mb-3">
          Fill the form and get an instant fare quote on WhatsApp
        </p>
        <p className="font-body text-[12px]" style={{ color: 'rgba(255,255,255,0.8)' }}>
          ⚡ Reply in 2 mins · ✓ No booking fee · ₹ Fare confirmed on WhatsApp
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-12 -mt-6">
        <div className="bg-white rounded-2xl border border-atithi-border shadow-xl p-6 lg:p-8">
          <CabBookingForm
            key={`${initialTripType}-${searchParams.get('from')}-${searchParams.get('to')}`}
            initialTripType={initialTripType}
            initialPickup={searchParams.get('from') || ''}
            initialDrop={searchParams.get('to') || ''}
            leadSource="Book Cab Page"
          />
        </div>
      </div>
    </div>
  );
};

export default VehicleBookingPage;
